import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useSyncExternalStore } from 'react';
import { dismissToast, getToastSnapshot, subscribeToToasts } from '../../utils/toast-store.js';
import { Toast, ToastContainer } from './Toast.js';
const emptyServerSnapshot = [];
export const ToastProvider = ({ children, position = 'top-right', }) => {
    const notifications = useSyncExternalStore(subscribeToToasts, getToastSnapshot, () => emptyServerSnapshot);
    return (_jsxs(_Fragment, { children: [children, _jsx(ToastContainer, { position: position, children: notifications.map((notification) => (_jsx(Toast, { id: notification.id, type: notification.type, message: notification.message, onDismiss: () => dismissToast(notification.id) }, notification.id))) })] }));
};
ToastProvider.displayName = 'ToastProvider';
//# sourceMappingURL=ToastProvider.js.map